import React, { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../../../services';
import moment from 'moment';
const pollingIntervalTime = 10000;
const maxPollingMinutes = 4;
export const useInsuranceData = (
  mypageStore,
  authStore,
  propInsurance,
  propPrice,
  propWaitingForPrice
) => {
  // State
  const [state, setState] = useState({
    fetchedDateTime: undefined,
    requestedDateTime: undefined,
    price: propPrice,
    discountExpirationDate: undefined,
    discountPrice: undefined,
    priceExpiration: undefined,
    waitingForPrice:
      propWaitingForPrice === undefined ? true : propWaitingForPrice,
    companyName: undefined,
    loadingToken: false,
  });

  // Refs to store interval
  const pollingIntervalRef = useRef(null);

  const fetchInsurancePrice = async (userUuid, vehicleId) => {
    try {
      const data = await api('getAgendaInsurancePrice', userUuid, vehicleId);
      setState((prev) => ({
        ...prev,
        ...data,
        companyName: data.companyName
          ? data.companyName.split(' ')[0].toLowerCase()
          : undefined,
      }));
    } catch (error) {
      setState((prev) => ({
        ...prev,
        waitingForPrice: false,
      }));
      console.error(error);
    }
  };

  const startPollingPrice = useCallback(() => {
    const userUuid = authStore.user
      ? authStore.user.attributes['custom:external_uuid']
      : undefined;

    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }

    const shouldPollPrice = () => {
      // insurance Expiring (expiring date <= 60 days) or Expired (expiring date < now)
      const isInsuranceExpiringOrExpired =
        propInsurance &&
        moment(propInsurance.node.date).isBefore(moment().add(60, 'days'));
      const selectedVehicle = mypageStore.selectedManageableVehicle;

      if (
        isInsuranceExpiringOrExpired &&
        selectedVehicle &&
        selectedVehicle.marketing_third_parties_consent_accepted
      ) {
        const priceExpirationDifference = moment.duration(
          moment().diff(moment(state.priceExpiration))
        );
        return (
          state.priceExpiration === undefined ||
          priceExpirationDifference.hours() > 0 ||
          priceExpirationDifference.minutes() > 0 ||
          priceExpirationDifference.seconds() > 0
        );
      }

      return false;
    };

    if (shouldPollPrice() && userUuid) {
      fetchInsurancePrice(userUuid, mypageStore.selectedManageableVehicle.uuid);
    }

    pollingIntervalRef.current = setInterval(() => {
      // condition for when to fetch price
      const difference = state.requestedDateTime
        ? moment.duration(moment().diff(moment(state.requestedDateTime)))
        : moment.duration(0);

      if (difference.hours() > 0 || difference.minutes() >= maxPollingMinutes) {
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
        }
        return;
      }

      if (state.waitingForPrice === false) {
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
        }
        return;
      }

      if (shouldPollPrice() && userUuid) {
        fetchInsurancePrice(
          userUuid,
          mypageStore.selectedManageableVehicle.uuid
        );
      } else {
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
        }
      }
    }, pollingIntervalTime);
  }, [
    authStore.user,
    propInsurance,
    state.priceExpiration,
    state.requestedDateTime,
    state.waitingForPrice,
    mypageStore.selectedManageableVehicle,
  ]);

  // Component lifecycle hooks using useEffect
  useEffect(() => {
    startPollingPrice();

    // Cleanup function
    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
      }
    };
  }, [startPollingPrice]);

  const handleLoadingToken = (loading) => {
    setState((prev) => ({
      ...prev,
      loadingToken: loading,
    }));
  };

  return {
    state,
    handleLoadingToken,
  };
};
